import { fieldService } from '../Service/fieldServices';
import {put, call } from 'redux-saga/effects';
import { fieldConstants } from '../actions/constants/fieldConstants';
import { cropidentifyConstants } from '../actions/constants/cropIdentifyConstant';

function* fieldall(request:any) {
    try {
        const response = yield call(fieldService.FieldService, request.payload); 
           
        if(response.statusCode === 201){
            yield put({
                type : fieldConstants.FieldAllSuccess,
                payload : response.resultObject
            });
        }else{
            yield put({
                type:fieldConstants.FieldAllFailure,
                payload: response.response.data.errorMessage
            });
        }      
      } catch (error) {

       

        yield put({
            type:fieldConstants.FieldAllFailure,
            payload: error
        });
      }
  }

  function* fielddelete(request:any) {
    try {
        const response = yield call(fieldService.FieldDelete, request.payload); 
        
        if(response.status === 200){
            yield put({
                type : fieldConstants.FieldDeleteAllSuccess,
                payload : response.data
            });
        }else{
            yield put({
                type:fieldConstants.FieldDeleteAllFailure,
                payload: response
            });
        }      
      } catch (error) {

        yield put({
            type:fieldConstants.FieldDeleteAllFailure,
            payload: error
        });
      }
  }


  function* fieldgroup(request:any) {
    try {
        const response = yield call(fieldService.Fieldgroup, request.payload); 
       
        if(response.statusCode === 200){
            yield put({
                type : fieldConstants.FieldgroupAllSuccess,
                payload : response.resultObject
            });
        }else{
            yield put({
                type:fieldConstants.FieldgroupAllFailure,
                payload: response.response.data.errorMessage
            });
        }      
      } catch (error) {

        yield put({
            type:fieldConstants.FieldgroupAllFailure,
            payload: error
        });
      }
  }

  function* fieldgroupAll() {
    try {
        const response = yield call(fieldService.FieldgroupgetAll); 
        
        if(response.statusCode === 200){
            yield put({
                type : fieldConstants.FieldgroupgetAllSuccess,
                payload : response.resultObject
            });
        }else{
            yield put({
                type:fieldConstants.FieldgroupgetAllFailure,
                payload: response.status
            });
        }      
      } catch (error) {

        yield put({
            type:fieldConstants.FieldgroupgetAllFailure,
            payload: error
        });
      }
  }

  function* fieldstatsVal(request:any) {
    try {
        const response = yield call(fieldService.Fieldstats,request.payload);  
        if(response.status === 200){
            yield put({
                type : cropidentifyConstants.StatsDataAllSuccess,
                payload : response.data.data[0].outputs.data.bands.B0.stats.mean
            });
        }else{
            yield put({
                type : cropidentifyConstants.StatsDataAllFailure,
                payload: response.status
            });
        }      
      } catch (error) {

        yield put({
            type:cropidentifyConstants.StatsDataAllFailure,
            payload: error
        });
      }
  }



  function* fieldname(request:any) {
    try {
        const response = yield call(fieldService.Fieldname,request.payload); 
   
        
        if(response.statusCode === 200){
            yield put({
                type : fieldConstants.FieldnamegetAllSuccess,
                payload : response.resultObject
            });
        }else{
            yield put({
                type:fieldConstants.FieldnamegetAllFailure,
                payload: response.status
            });
        }      
      } catch (error) {

        yield put({
            type:fieldConstants.FieldnamegetAllFailure,
            payload: error
        });
      }
  }

  function* fieldState(request:any) {
    try {
        const response = yield call(fieldService.FieldState,request.payload); 
        
        if(response.statusCode === 200){
            yield put({
                type : fieldConstants.FieldStateAllSuccess,
                payload : response.resultObject
            });
        }else{
            yield put({
                type:fieldConstants.FieldStateAllFailure,
                payload: response.status
            });
        }      
      } catch (error) {

        yield put({
            type:fieldConstants.FieldStateAllFailure,
            payload: error
        });
      }
  }

  export const FieldSaga = {
    fieldall,fieldgroup,fieldgroupAll,fieldstatsVal,fieldname,fieldState,fielddelete
  }